<template>
  <section class="form-section">
    <div class="form-section__head">
      <h3>판매신청 제품</h3>
    </div>
    <div>
      <dl class="form-list__row form-list__row--text-only">
        <dt class="form-list__key">
          {{ ordInfo.prchClsfName }}
        </dt>
        <dd style="min-height: 20px;">
          <div>{{ ordInfo.ptnmNm }}</div>
        </dd>
      </dl>
      <dl class="form-list__row form-list__row--text-only">
        <dt class="form-list__key">
          입금시기
        </dt>
        <dd>
          <div v-html="ordInfo.depositMsg">
          </div>
        </dd>
      </dl>
      <dl class="form-list__row form-list__row--text-only">
        <dt class="form-list__key">
          판매가격
        </dt>
        <dd>
          <div :class="{'font-red': !isPrePaymentOrder}" v-html="ordInfo.pymtAmtMsg" />
        </dd>
      </dl>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PrchModlInfo',
  components: {

  },
  props: ['ordInfo'],
  data: () => ({

  }),
  computed: {
    isPrePaymentOrder () {
      return this.ordInfo.corporationCode === '020200'
    }
  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/sale/components/PrchModlInfo.vue